import {createApi} from '@reduxjs/toolkit/query/react'
import api from 'services/api'
import axios from 'axios'
import storage from 'services/storage'
import store, {setApiError} from 'store/Store'
// import storage from 'services/storage'

export const transformResponseFromData = (response) => {
    console.log('api response', response)
    return response
}
export const transformResponseFromMessage = (response) => response.message

export const provideTags = (tagName, data, tagField) => {
    console.log('provide tags data', tagName, data)
    return data
        ? [
              ...data?.map((item) => ({
                  type: tagName,
                  id: item[tagField || '_id'],
              })),
              {type: tagName, id: 'LIST'},
          ]
        : [{type: tagName, id: 'LIST'}]
}
export const provideTag = (tagName, data, tagField) => {
    console.log('provide tag data', tagName, data)
    return data
        ? [{type: tagName, id: data[tagField || '_id']}]
        : [{type: tagName, id: 'LIST'}]
}

export const sendAxiosRequest = (baseUrl, url, method, body, headers) =>
    axios({
        url: `${baseUrl}/${url}`,
        method,
        data: body,
        // withCredentials: true,
        ...(headers && {headers: headers({})}),
    })

const prepareBaseUrl = (baseUrl, url) => {
    let cleanBaseUrl = '' + baseUrl

    if (url === 'token') {
        cleanBaseUrl = baseUrl.replace('/api', '')
    }
    return cleanBaseUrl
}

const prepareBody = (body) =>
    typeof body === 'string' ? body : JSON.stringify(body)

const throwIfError = (data) => {
    // store.dispatch(
    //     setApiError({
    //         success: false,
    //         title: 'api error title',
    //         msg: 'api error message',
    //         button: 'api error button',
    //         url: '/clients',
    //     })
    // )
    if (data?.success === false) {
        store.dispatch(setApiError(data))
        const error = {
            response: {
                status: 200,
                data: data?.msg,
            },
        }
        throw error
    }
}

const axiosBaseQuery =
    ({baseUrl, headers} = {baseUrl: '', headers: ''}) =>
    async ({url, method, body}) => {
        const cleanBaseUrl = prepareBaseUrl(baseUrl, url)
        body = prepareBody(body)

        console.log(
            'axios basic query',
            `${cleanBaseUrl}/${url}`,
            method,
            headers,
            body
        )

        try {
            const result = await sendAxiosRequest(
                cleanBaseUrl,
                url,
                method,
                body,
                url === 'token' ? null : headers
            )

            console.log('axios response', `${cleanBaseUrl}/${url}`, result)
            // {
            //     ...headers,
            //     'Access-Control-Allow-Credentials': true,
            // })
            throwIfError(result.data)
            return {data: result.data}
        } catch (axiosError) {
            const responseError = {
                // data: err.response?.data,
                error: {
                    status: axiosError.response?.status,
                    data: axiosError.response?.data,
                },
            }

            // handle refresh
            if (
                axiosError.response?.status === 401 &&
                url !== 'auth/refreshToken'
            ) {
                try {
                    console.log('requesting refresh')
                    const refreshResult = await sendAxiosRequest(
                        baseUrl,
                        'auth/refreshToken',
                        method,
                        body,
                        headers
                    )
                    console.log('refresh result', refreshResult)

                    const result = await sendAxiosRequest(
                        baseUrl,
                        url,
                        method,
                        body,
                        headers
                    )
                    return {data: result.data}
                } catch (refreshError) {
                    console.log('refresh error', refreshError, responseError)
                    return responseError
                }
            }

            console.log('axios error', responseError)
            return responseError
        }
    }

const getHeaders = () => {
    const bearerToken = storage.getLoginCredentials()?.token
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: bearerToken ? `Bearer ${bearerToken}` : undefined,
    }
}
const baseApi = createApi({
    baseQuery: axiosBaseQuery({
        baseUrl: api.baseUrl,
        headers: () => getHeaders(),
    }),
    reducerPath: 'api',
    tagTypes: ['CurrentUser', 'Account', 'User', 'Client', 'Note', 'Crm'],
    endpoints: () => ({}),
})

export default baseApi
